module.exports = false;



// WEBPACK FOOTER //
// node_modules/_core-js@2.5.6@core-js/modules/_library.js